// src/pages/Archive/index.jsx
import React, { useState, useEffect } from 'react';
import { Layout, Typography, Timeline, Card, Tag, Empty, Spin } from 'antd';
import { CalendarOutlined } from '@ant-design/icons';
import AppHeader from '../../components/Header';
import AppFooter from '../../components/Footer';
import { useBlog } from '../../context/BlogContext'; // 导入 BlogContext
import './index.css';

const { Content } = Layout;
const { Title, Text } = Typography;

const Archive = ({ loggedInUser, onLogout }) => {
  const [archiveData, setArchiveData] = useState([]);
  const [loading, setLoading] = useState(true);
  const { posts, loading: blogLoading } = useBlog(); // 使用 BlogContext

  useEffect(() => {
    const generateArchiveData = (posts) => {
      if (!posts || posts.length === 0) return [];
      
      const archiveMap = {};
      
      // 按年份分组文章
      posts.forEach(post => {
        const year = new Date(post.createdAt).getFullYear().toString();
        if (!archiveMap[year]) {
          archiveMap[year] = [];
        }
        archiveMap[year].push(post);
      });
      
      // 转换为数组并按年份降序排列
      const result = Object.keys(archiveMap)
        .sort((a, b) => b - a)
        .map(year => {
          // 按日期降序排列该年份的文章
          const sortedPosts = archiveMap[year].sort((a, b) => 
            new Date(b.createdAt) - new Date(a.createdAt)
          );
          
          return {
            year,
            posts: sortedPosts.map(post => ({
              id: post.id,
              title: post.title,
              date: new Date(post.createdAt).toLocaleDateString('zh-CN'),
              category: post.category
            }))
          };
        });
      
      return result;
    };

    // 当 posts 数据加载完成时，生成归档数据
    if (!blogLoading) {
      const data = generateArchiveData(posts);
      setArchiveData(data);
      setLoading(blogLoading);
    }
  }, [posts, blogLoading]);

  return (
    <Layout className="blog-layout">
      <AppHeader loggedInUser={loggedInUser} onLogout={onLogout} />
      <Content className="blog-content archive-content">
        <div className="archive-container">
          <Title level={2} className="archive-title">
            <CalendarOutlined /> 文章归档
          </Title>
          
          {(loading || blogLoading) ? (
            <div className="home-loading">
              <Spin size="large" tip="加载中..." />
            </div>
          ) : archiveData.length > 0 ? (
            <div className="archive-timeline">
              {archiveData.map((yearData) => (
                <div key={yearData.year} className="archive-year-section">
                  <Title level={3} className="archive-year-title">
                    {yearData.year}年
                  </Title>
                  <Timeline>
                    {yearData.posts.map((post) => (
                      <Timeline.Item 
                        key={post.id} 
                        dot={<CalendarOutlined style={{ fontSize: '16px' }} />}
                      >
                        <Card className="archive-post-card" size="small">
                          <div className="post-info">
                            <Text className="post-date">{post.date}</Text>
                            <Tag className="post-category">{post.category}</Tag>
                          </div>
                          <Text className="post-title">{post.title}</Text>
                        </Card>
                      </Timeline.Item>
                    ))}
                  </Timeline>
                </div>
              ))}
            </div>
          ) : (
            <Empty
              description="暂无归档文章"
              image={Empty.PRESENTED_IMAGE_SIMPLE}
            />
          )}
        </div>
      </Content>
      <AppFooter />
    </Layout>
  );
};

export default Archive;